import { capitalize, Chip, Tooltip, Typography } from "@mui/material";
import { Tag } from "~/operations";
import { FormatAbbrDateMonthYear } from "~/lib/date";
import { normalizeDate } from "~/lib/normalizeDateToIso";

interface FirewatchChipProps {
  tag: NonNullable<Tag>;
  inactive?: boolean;
}

const ChipText = ({ tag }: FirewatchChipProps) => {
  // The only tag that has a text value at the moment is policies. So we need to handle it differently.
  const isPolicy = tag.key.toLocaleLowerCase() === "policies";

  const normalized = isPolicy ? null : normalizeDate(tag.value);
  const baseValue = normalized
    ? FormatAbbrDateMonthYear(normalized)
    : tag.value;

  // Clamp long policy names to 30 characters and add an ellipsis
  const tagValue = isPolicy
    ? baseValue.length > 30
      ? baseValue.slice(0, 30) + "..."
      : baseValue
    : baseValue;

  return (
    <Tooltip title={isPolicy ? tag.value : ""} arrow>
      <Typography
        sx={{
          fontSize: 12,
          color: "text.secondary",
        }}
      >
        {capitalize(tag.key)}{" "}
        <Typography component="span" sx={{ fontSize: 12, fontWeight: 700 }}>
          {tagValue}
        </Typography>
      </Typography>
    </Tooltip>
  );
};

export function FirewatchChip({ tag, inactive = false }: FirewatchChipProps) {
  return (
    <Chip
      label={<ChipText {...{ tag }} />}
      data-testid={tag.key.split(" ").join("-")}
      variant="filled"
      size="small"
      className="firewatch-chip"
      sx={{
        borderRadius: "4px",
        backgroundColor: "background.light",
        color: "text.secondary",
        transition: "all 0s",
        opacity: inactive ? 0.33 : 1,
      }}
    />
  );
}
